(function () {
  let swiperInstance;

  const initSlider = (section) => {
    const slider = section.querySelector(".swiper--tech-stack");
    const wrapper = section.querySelector(".tech-stack-grid");

    if (!slider || !wrapper) return;

    const slides = wrapper.querySelectorAll(".partner-card");

    // Add required swiper classes
    wrapper.classList.add("swiper-wrapper");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    // Prevent multiple init
    if (slider.swiper) return;

    swiperInstance = new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      speed: 600,
      watchSlidesProgress: true,

      breakpoints: {
        576: {
          spaceBetween: 8,
        },
        768: {
          spaceBetween: 16,
        },
        1024: {
          spaceBetween: 20,
        },
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--tech-stack");
    const slides = section.querySelectorAll(".partner-card");
    const wrapper = section.querySelector(".tech-stack-grid");

    if (slider?.swiper) {
      slider.swiper.destroy(true, true);
    }

    if (wrapper) {
      wrapper.classList.remove("swiper-wrapper");
    }

    slides.forEach((slide) => {
      slide.classList.remove("swiper-slide");
      slide.removeAttribute("style");
    });
  };

  const handleResize = (section) => {
    const enableSlider = section.classList.contains("tech-stack-section");

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && enableSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    observer.observe(section);
  };

  const init = (section) => {
    if (!section || !section.classList.contains("tech-stack-section")) return;
    handleResize(section);
  };

  // Initial load
  init(document.currentScript.closest(".shopify-section"));

  // Shopify editor support
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();